// MonthlyTransactionCard.js
import React, { useEffect, useState } from 'react';
import {
  Card, CardBody, CardTitle, CardText, Spinner, CardFooter, Button
} from 'reactstrap';
import api from '../services/api';

const MonthlyTransactionCard = () => {
  const [summary, setSummary] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/transactions/monthly-summary/'),
      api.get('/get-org-details/')
    ])
      .then(([summaryResponse, orgResponse]) => {
        setSummary(summaryResponse.data);
        setOrganization(orgResponse.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, []);

  if (loading || !summary) {
    return <Spinner color="primary" />;
  }

  return (
    <Card className="mb-3">
      <CardBody>
        <CardTitle tag="h5" className="text-center">{summary.month} Transactions</CardTitle>
        <CardText className="text-center h1 font-weight-bold">
          {summary.transaction_count}
        </CardText>
      </CardBody>
      {organization?.reporting_link && (
        <CardFooter className="text-center">
          <Button
            color="link"
            size="sm"
            onClick={() => window.open(organization.reporting_link, '_blank')}
          >
            View Full Report
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};

export default MonthlyTransactionCard;
